import React from 'react';
import { withTranslation } from 'react-i18next';
import type { FormikValues } from 'formik';
import { withFormik } from 'formik';
import { object, string } from 'yup';

import HttpService from 'src/services/api/http';
import type { AfterLoginCallback } from 'src/components/app/context/LoginConsumer';
import LoginConsumer from 'src/components/app/context/LoginConsumer';
import LoginForm from 'src/components/account/LoginPage/components/LoginForm';

const validationSchema = ({ t }: any) =>
  object().shape({
    email: string().required(t('emailMissing')).email(t('emailWrongFormat')),
    password: string().required(t('passwordMissing')),
  });

export const handleSubmit = (
  { email, password }: { email: string; password: string },
  { setSubmitting, setErrors, props }: FormikValues,
) => {
  setSubmitting(true);

  return HttpService.post('account/login/', { email, password })
    .then((response) => {
      setSubmitting(false);
      // Sets auth token in session storage, loads userContext, triggers provided onDone()
      props.afterLogin(response.data.key, props.onDone);

      return true;
    })
    .catch(({ response }) => {
      setSubmitting(false);
      const [error, msg] = response?.data?.non_field_errors || [];
      if (error === 'invalid') {
        setErrors({ nonFieldErrors: msg });
      } else {
        setErrors({ authError: true });
      }
      return false;
    });
};

const LoginFormContainer = withTranslation('login')(
  withFormik({
    mapPropsToValues: () => ({ email: '', password: '' }),
    validationSchema,
    handleSubmit,
  })(LoginForm),
);

const LoginFormContainerContextConsumer = (props: any) => (
  <LoginConsumer
    render={(afterLogin: AfterLoginCallback) => (
      <LoginFormContainer {...props} afterLogin={afterLogin} />
    )}
  />
);

export default LoginFormContainerContextConsumer;
